import { Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { decrement, increment } from './dashboardSlice';
import { styles } from '../../style/style'
import Grid from '@mui/material/Grid';
import { Box, InputBase } from '@mui/material';

export default function Dashboard() {

    const count = useSelector((state) => state.dashboard.value);
    const dispatch = useDispatch();

    return(
        <Box>
            <Grid container sx={styles.masterMargin}>
            <div>
                <Typography variant="h2" sx={styles.h2PageTitle}><>Dashboard</></Typography>
                <div>
                    <Grid item sx={{pt:'20%'}}>
                        <button
                        aria-label="Increment value"
                        onClick={() => dispatch(increment())}
                        >
                        Increment
                        </button>
                        <span>{count}</span>
                        <button
                        aria-label="Decrement value"
                        onClick={() => dispatch(decrement())}
                        >
                        Decrement
                        </button>
                    </Grid>
                </div>

                </div>
            </Grid>
        </Box>
    )
}